<template>
  <div class="tooltip-popup" :class="[classes, ...position]">
    <slot>{{ content }}</slot>
  </div>
</template>
<script>
const isOutOfView = element => {
  const { top, bottom, left, right } = element.getBoundingClientRect();

  const height = window.innerHeight || document.documentElement.clientHeight;
  const width = window.innerWidth || document.documentElement.clientWidth;

  const temp = { top: false, bottom: false, left: false, right: false };

  if (top < 0) temp.top = true;
  if (bottom > height && top > height * 0.7) temp.bottom = true; // only if top is > than 70% of height
  if (left < 0) temp.left = true;
  if (right > width) temp.right = true;

  return temp;
};

const dropdownPosition = element => {
  const out = isOutOfView(element);
  return Object.entries(out).reduce(
    (acc, [key, value]) => (value && (acc = [...acc, key]), acc),
    [],
  );
};

export default {
  name: 'TooltipPopup',
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      selected: {},
      position: [],
    };
  },
  methods: {
    handleSelect(selection) {
      this.$emit('select', selection);
    },
  },
  mounted() {
    this.position = dropdownPosition(this.$el);
  },
};
</script>
